import { render } from "./AllServiceComponent.vue?vue&type=template&id=41c821af&scoped=true"
import script from "./AllServiceComponent.vue?vue&type=script&lang=js"
export * from "./AllServiceComponent.vue?vue&type=script&lang=js"

import "./AllServiceComponent.vue?vue&type=style&index=0&id=41c821af&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41c821af"]])

export default __exports__